module.exports = __webpack_public_path__ + "img/article12.0c222592.jpg";